import { Type, Contrast, BookOpen } from "lucide-react";

const SCALE_LABELS = { 1: "A", 1.2: "A+", 1.5: "A++" };
const SCALE_NAMES = { 1: "Standard", 1.2: "Large", 1.5: "Extra large" };

export default function AccessibilityBar({ a11y, setA11y }) {
  const cycleScale = () => {
    const next = a11y.scale === 1 ? 1.2 : a11y.scale === 1.2 ? 1.5 : 1;
    setA11y((s) => ({ ...s, scale: next }));
  };

  const btn =
    "flex h-12 w-12 items-center justify-center rounded-full text-slate-200 transition-colors duration-200 hover:bg-[#00D4FF]/15 hover:text-[#00D4FF]";

  return (
    <div
      role="region"
      aria-label="Accessibility controls"
      data-testid="accessibility-bar"
      className="glass-panel fixed bottom-5 right-5 z-50 flex items-center gap-1.5 rounded-full p-1.5 shadow-[0_8px_32px_rgba(0,0,0,0.45)]"
    >
      <button
        type="button"
        className={`${btn} font-display text-sm font-bold ${a11y.scale !== 1 ? "bg-[#00D4FF]/20 text-[#00D4FF]" : ""}`}
        onClick={cycleScale}
        aria-label={`Text size: ${SCALE_NAMES[a11y.scale]}. Activate to change.`}
        data-testid="a11y-text-size-button"
        title="Text size"
      >
        <span className="flex items-center gap-1">
          <Type className="h-4 w-4" aria-hidden="true" />
          {SCALE_LABELS[a11y.scale]}
        </span>
      </button>
      <button
        type="button"
        className={`${btn} ${a11y.hc ? "bg-[#00D4FF]/20 text-[#00D4FF]" : ""}`}
        onClick={() => setA11y((s) => ({ ...s, hc: !s.hc }))}
        aria-pressed={a11y.hc}
        aria-label="Toggle ultra high contrast mode"
        data-testid="a11y-contrast-toggle"
        title="High contrast"
      >
        <Contrast className="h-5 w-5" aria-hidden="true" />
      </button>
      <button
        type="button"
        className={`${btn} ${a11y.dyslexic ? "bg-[#00D4FF]/20 text-[#00D4FF]" : ""}`}
        onClick={() => setA11y((s) => ({ ...s, dyslexic: !s.dyslexic }))}
        aria-pressed={a11y.dyslexic}
        aria-label="Toggle dyslexia friendly font"
        data-testid="a11y-dyslexic-toggle"
        title="Dyslexia friendly font"
      >
        <BookOpen className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  );
}
